import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, SparklesIcon, TargetIcon, BookOpenIcon, UsersIcon } from 'lucide-react';
interface SummaryScreenProps {
  onSubmit: () => void;
}
export function SummaryScreen({
  onSubmit
}: SummaryScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.5
  }} className="flex flex-col items-center text-center max-w-2xl mx-auto pt-8" data-id="element-68">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-8" data-id="element-69">
        <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-70" />
      </div>

      <h2 className="text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-71">
        Thank you
      </h2>

      <p className="text-lg text-slate-600 mb-10 leading-relaxed max-w-lg" data-id="element-72">
        Your answers help us design a congress engagement strategy built around:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full mb-12" data-id="element-73">
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col items-center" data-id="element-74">
          <TargetIcon className="w-8 h-8 text-minerva mb-3" data-id="element-75" />
          <span className="font-medium text-navy" data-id="element-76">Market insights</span>
        </div>
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col items-center" data-id="element-77">
          <BookOpenIcon className="w-8 h-8 text-minerva mb-3" data-id="element-78" />
          <span className="font-medium text-navy" data-id="element-79">Interactive education</span>
        </div>
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col items-center" data-id="element-80">
          <UsersIcon className="w-8 h-8 text-minerva mb-3" data-id="element-81" />
          <span className="font-medium text-navy" data-id="element-82">High-quality leads</span>
        </div>
      </div>

      <div className="w-full bg-slate-100 p-8 rounded-2xl mb-12 text-left" data-id="element-83">
        <h3 className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-84">
          <SparklesIcon className="w-4 h-4" data-id="element-85" />
          Next Steps
        </h3>
        <p className="text-navy font-medium mb-4" data-id="element-86">
          We will use this information to design:
        </p>
        <ul className="space-y-3" data-id="element-87">
          <li className="flex items-start gap-3" data-id="element-88">
            <div className="w-1.5 h-1.5 rounded-full bg-minerva mt-2 shrink-0" data-id="element-89" />
            <span className="text-slate-700" data-id="element-90">A congress market poll Snak</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-91">
            <div className="w-1.5 h-1.5 rounded-full bg-minerva mt-2 shrink-0" data-id="element-92" />
            <span className="text-slate-700" data-id="element-93">
              A trust-building Trailer Snak for booth demos
            </span>
          </li>
        </ul>
      </div>

      <button onClick={onSubmit} className="px-10 py-4 bg-navy text-white font-semibold text-lg rounded-xl transition-all hover:bg-navy-light hover:shadow-lg active:scale-[0.98]" data-id="element-94">
        Submit Answers
      </button>
    </motion.div>;
}